import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './ClinicalResearch.css';
// import Navbar from './navbar';

const ClinicalResearch = ({ portNumber }) => {
    const location = useLocation();
    // const [showIframe, setShowIframe] = useState(false);
    // const [selectedCard, setSelectedCard] = useState(null);
    const [iframeLoading, setIframeLoading] = useState(true);
    const [cortexToken, setCortexToken] = useState(null);
    const [cortexAuthLoading, setCortexAuthLoading] = useState(false);
    const [cortexAuthError, setCortexAuthError] = useState(null);

    const title = portNumber === "3001" ? "R&D" : "Sponsored Research";

    useEffect(() => {
        const controller = new AbortController();


        async function loginToCortex() {
            setCortexAuthLoading(true);
            setCortexAuthError(null);
            try {
                const response = await fetch(`https://s2.genetica.ai:${portNumber}/Cortex/Users/$login`, {
                    method: 'POST',
                    headers: {
                        'accept': 'application/json, text/plain, */*',
                        'accept-language': 'en-US,en;q=0.9',
                        'authorization': 'Basic ZjJhOmYyYTExMQ==',
                        'content-type': 'application/json',
                        'origin': `https://s2.genetica.ai:${portNumber}`,
                        'priority': 'u=1, i',
                        'referer': `https://s2.genetica.ai:${portNumber}/apps/cortex/`,
                        'sec-ch-ua': '"Google Chrome";v="143", "Chromium";v="143", "Not A(Brand";v="24"',
                        'sec-ch-ua-mobile': '?0',
                        'sec-ch-ua-platform': '"Windows"',
                        'sec-fetch-dest': 'empty',
                        'sec-fetch-mode': 'cors',
                        'sec-fetch-site': 'same-origin',
                        'user-agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/143.0.0.0 Safari/537.36'
                    },
                    body: JSON.stringify(["cortex"]),
                    signal: controller.signal,
                });

                if (!response.ok) {
                    throw new Error(`Cortex login failed (${response.status})`);
                }

                const data = await response.json();
                // expected: { token: "..." } (fallbacks included just in case)
                const token = data?.token || data?.data?.token || data?.accessToken || null;
                if (!token) {
                    throw new Error("Cortex token missing in response");
                }

                setCortexToken(token);
            } catch (err) {
                if (err?.name === "AbortError") return;
                setCortexAuthError(err?.message || "Cortex login failed");
            } finally {
                setCortexAuthLoading(false);
            }
        }

        loginToCortex();

        return () => controller.abort();
    }, [location.key, portNumber]);

    

    const handleIframeLoad = () => {
        console.log('Iframe loaded successfully');
        setIframeLoading(false);
    };

    const handleIframeError = () => {
        console.log('Iframe failed to load');
        setIframeLoading(false);
    };

   

    return (
        <div className="clinicalresearch-wrapper">
            {/* Navbar - Only show when not in iframe mode */}
            {/* {!showIframe && (
       <Navbar />
      )} */}
      <h4 style={{ marginTop: "0px" }}>My Research - {title}</h4>

            {/* Main Content */}
            <main className="clinicalresearch-main">

                <div className="clinicalresearch-iframe-container">
                    {(cortexAuthLoading || cortexAuthError) && (
                        <div className="clinicalresearch-iframe-loading">
                            {cortexAuthLoading ? (
                                <>
                                    <div className="loading-spinner"></div>
                                    <p>Signing in to Cortex...</p>
                                </>
                            ) : (
                                <p style={{ color: "#b91c1c" }}>{cortexAuthError}</p>
                            )}
                        </div>
                    )}
                    {/* <div className="iframe-header">
                            <div className="iframe-title"> */}
                    {/* <span>{selectedCard?.title || 'Content'}</span> */}
                    {/* </div>
                            <button className="iframe-close-btn" onClick={handleClose} title="Close">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </button> */}
                    {/* </div> */}
                    {iframeLoading && cortexToken && (
                        <div className="clinicalresearch-iframe-loading">
                            <div className="loading-spinner"></div>
                            <p>Loading content...</p>
                        </div>
                    )}
                    <iframe
                        // src="https://65.19.132.215:3001"
                        src={
                            cortexToken
                                ? `https://s2.genetica.ai:${portNumber}/apps/cortex/#/dashboard/graphs/list?token=${cortexToken}`
                                : undefined
                        }
                        // title={selectedCard?.title || 'Content'}
                        className="clinicalresearch-iframe"
                        frameBorder="0"
                        allowFullScreen
                        onLoad={handleIframeLoad}
                        onError={handleIframeError}
                    />
                </div>

            </main>
        </div>
    );
};

export default ClinicalResearch;

